export const NOTIFICATION_TEMPLATE_TRAINING_PLANNED_TODAY_REMINDER =
  'TRAINING_PLANNED_TODAY_REMINDER' as const;

export const NOTIFICATION_TEMPLATE_TRAINING_INACTIVITY_REMINDER =
  'TRAINING_INACTIVITY_REMINDER' as const;

export const NOTIFICATION_TEMPLATE_SYSTEM_MAINTENANCE_PLANNED =
  'SYSTEM_MAINTENANCE_PLANNED' as const;

export const NOTIFICATION_TEMPLATE_WALL_POST_ON_USER_PAGE =
  'WALL_POST_ON_USER_PAGE' as const;

export const NOTIFICATION_TEMPLATE_POST_COMMENTED = 'POST_COMMENTED' as const;

export const NOTIFICATION_TEMPLATE_USER_SUBSCRIPTION_APPROVED =
  'USER_SUBSCRIPTION_APPROVED' as const;

export const NOTIFICATION_TEMPLATE_TRAINING_ACCESS_GRANTED =
  'TRAINING_ACCESS_GRANTED' as const;

export const NOTIFICATION_TEMPLATE_TRAINING_SHARED_WITH_USER =
  'TRAINING_SHARED_WITH_USER' as const;

export const NOTIFICATION_TEMPLATE_PROGRAM_ITEM_SHARED_WITH_USER =
  'PROGRAM_ITEM_SHARED_WITH_USER' as const;

export const NOTIFICATION_TEMPLATE_TRAINING_CREATED_FOR_OWNER =
  'TRAINING_CREATED_FOR_OWNER' as const;

export const NOTIFICATION_TEMPLATE_PROGRAM_ASSIGNED =
  'PROGRAM_ASSIGNED' as const;

export const NOTIFICATION_TEMPLATE_PROGRAM_UPDATED = 'PROGRAM_UPDATED' as const;

export const NOTIFICATION_TEMPLATE_TRAINING_COMPLETED =
  'TRAINING_COMPLETED' as const;

export const NOTIFICATION_TEMPLATE_TRAINING_SCHEDULED =
  'TRAINING_SCHEDULED' as const;

export const NOTIFICATION_TEMPLATE_USER_PROFILE_UPDATED =
  'USER_PROFILE_UPDATED' as const;

export const NOTIFICATION_TEMPLATE_USER_MENTIONED = 'USER_MENTIONED' as const;

export const NOTIFICATION_TEMPLATE_COMMUNITY_INVITE =
  'COMMUNITY_INVITE' as const;

export const NOTIFICATION_TEMPLATE_PAYMENT_SUCCEEDED =
  'PAYMENT_SUCCEEDED' as const;

export const NOTIFICATION_TEMPLATE_PAYMENT_FAILED = 'PAYMENT_FAILED' as const;

export const NOTIFICATION_TEMPLATE_SUBSCRIPTION_RENEWED =
  'SUBSCRIPTION_RENEWED' as const;

export const NOTIFICATION_TEMPLATE_SUBSCRIPTION_EXPIRING =
  'SUBSCRIPTION_EXPIRING' as const;

export const NOTIFICATION_TEMPLATE_CHAT_MESSAGE_RECEIVED =
  'CHAT_MESSAGE_RECEIVED' as const;

export const NOTIFICATION_TEMPLATE_EXERCISE_UPDATED =
  'EXERCISE_UPDATED' as const;

export const NOTIFICATION_TEMPLATE_FILE_PROCESSING_COMPLETE =
  'FILE_PROCESSING_COMPLETE' as const;

export const NOTIFICATION_TEMPLATE_SYNC_CONFLICT = 'SYNC_CONFLICT' as const;

export const NOTIFICATION_TEMPLATE_BUG_REPORT_STATUS_CHANGED =
  'BUG_REPORT_STATUS_CHANGED' as const;

export const NOTIFICATION_TEMPLATE_WORKOUT_REMINDER =
  'WORKOUT_REMINDER' as const;

export const NOTIFICATION_TEMPLATE_HASHTAG_TRENDING =
  'HASHTAG_TRENDING' as const;

export const NOTIFICATION_TEMPLATE_ADMIN_MESSAGE = 'ADMIN_MESSAGE' as const;

export const NOTIFICATION_TEMPLATE_CODES_IMPLEMENTED = [
  NOTIFICATION_TEMPLATE_TRAINING_PLANNED_TODAY_REMINDER,
  NOTIFICATION_TEMPLATE_TRAINING_INACTIVITY_REMINDER,
  NOTIFICATION_TEMPLATE_SYSTEM_MAINTENANCE_PLANNED,
  NOTIFICATION_TEMPLATE_WALL_POST_ON_USER_PAGE,
  NOTIFICATION_TEMPLATE_POST_COMMENTED,
  NOTIFICATION_TEMPLATE_USER_SUBSCRIPTION_APPROVED,
  NOTIFICATION_TEMPLATE_TRAINING_ACCESS_GRANTED,
  NOTIFICATION_TEMPLATE_TRAINING_SHARED_WITH_USER,
  NOTIFICATION_TEMPLATE_PROGRAM_ITEM_SHARED_WITH_USER,
  NOTIFICATION_TEMPLATE_TRAINING_CREATED_FOR_OWNER,
] as const;

export const NOTIFICATION_TEMPLATE_CODES_RESERVED = [
  NOTIFICATION_TEMPLATE_PROGRAM_ASSIGNED,
  NOTIFICATION_TEMPLATE_PROGRAM_UPDATED,
  NOTIFICATION_TEMPLATE_TRAINING_COMPLETED,
  NOTIFICATION_TEMPLATE_TRAINING_SCHEDULED,
  NOTIFICATION_TEMPLATE_USER_PROFILE_UPDATED,
  NOTIFICATION_TEMPLATE_USER_MENTIONED,
  NOTIFICATION_TEMPLATE_COMMUNITY_INVITE,
  NOTIFICATION_TEMPLATE_PAYMENT_SUCCEEDED,
  NOTIFICATION_TEMPLATE_PAYMENT_FAILED,
  NOTIFICATION_TEMPLATE_SUBSCRIPTION_RENEWED,
  NOTIFICATION_TEMPLATE_SUBSCRIPTION_EXPIRING,
  NOTIFICATION_TEMPLATE_CHAT_MESSAGE_RECEIVED,
  NOTIFICATION_TEMPLATE_EXERCISE_UPDATED,
  NOTIFICATION_TEMPLATE_FILE_PROCESSING_COMPLETE,
  NOTIFICATION_TEMPLATE_SYNC_CONFLICT,
  NOTIFICATION_TEMPLATE_BUG_REPORT_STATUS_CHANGED,
  NOTIFICATION_TEMPLATE_WORKOUT_REMINDER,
  NOTIFICATION_TEMPLATE_HASHTAG_TRENDING,
  NOTIFICATION_TEMPLATE_ADMIN_MESSAGE,
] as const;

export const NOTIFICATION_TEMPLATE_CODES_ALL = [
  ...NOTIFICATION_TEMPLATE_CODES_IMPLEMENTED,
  ...NOTIFICATION_TEMPLATE_CODES_RESERVED,
] as const;

export type NotificationTemplateCodeId =
  (typeof NOTIFICATION_TEMPLATE_CODES_ALL)[number];
